export default "__VITE_ASSET__CGcYkZ5e__"